import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated="June 12, 2026">
      <p>
        KELTA — Kerala Local Body Technical Assistants Association ("KELTA", "we", "us")
        respects the privacy of every member and visitor. This Privacy Policy explains
        what information we collect through <strong>kelta.co.in</strong>, how we use it,
        and the choices you have about your data.
      </p>

      <h2>1. Information We Collect</h2>
      <h3>1.1 Information you provide</h3>
      <ul>
        <li><strong>Personal details</strong> — full name, gender, date of birth, postal address, photograph.</li>
        <li><strong>Contact details</strong> — email address, mobile number.</li>
        <li><strong>Official details</strong> — employee ID, designation, department, local body type and name, district, date of joining, years of service.</li>
        <li><strong>Account credentials</strong> — password (stored only as a salted bcrypt hash; we never see or store your password in plain text).</li>
      </ul>
      <h3>1.2 Information collected automatically</h3>
      <ul>
        <li>Authentication cookies that keep you signed in.</li>
        <li>Basic technical logs (IP address, browser type, requested page, timestamp) for security and diagnostics.</li>
      </ul>
      <h3>1.3 Payment information</h3>
      <p>
        Payment processing is handled entirely by Razorpay Software Private Limited.
        KELTA does <strong>not</strong> see, collect or store your card number, CVV,
        UPI PIN, net banking credentials or any other sensitive financial data. We
        receive only a transaction reference, payment status, method, amount and date.
      </p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To register you as a KELTA member and verify your eligibility.</li>
        <li>To issue your digital membership ID card and QR verification link.</li>
        <li>To send transactional emails (registration, approval, payment receipts, renewal reminders, event updates).</li>
        <li>To operate the Member Directory and District Unit pages.</li>
        <li>To respond to help-desk tickets and provide technical support.</li>
        <li>To comply with applicable legal obligations.</li>
      </ul>

      <h2>3. Public vs. Private Data</h2>
      <p>
        The following profile details may appear publicly on the Member Directory and
        QR verification page once your membership is active: <em>full name, photograph,
        designation, district, local body name and type, membership ID, membership status,
        and expiry date</em>. All other information (date of birth, address, mobile number,
        email, employee ID) is kept private and accessible only to KELTA administrators.
      </p>

      <h2>4. Sharing of Information</h2>
      <p>We do not sell or rent your personal information. We may share data only:</p>
      <ul>
        <li>With Razorpay, strictly for processing your payment.</li>
        <li>With trusted service providers who help us run the website (hosting, email delivery), under appropriate confidentiality obligations.</li>
        <li>If required by law, court order, or to protect the rights and safety of KELTA, its members, or the public.</li>
      </ul>

      <h2>5. Data Retention</h2>
      <p>
        We retain your profile, payment history and ticket records for as long as your
        membership is active and for a reasonable period thereafter for audit and
        regulatory purposes. You may request earlier deletion by emailing
        <a href="mailto:keltastate@gmail.com"> keltastate@gmail.com</a>.
      </p>

      <h2>6. Security</h2>
      <ul>
        <li>Passwords are stored only as bcrypt hashes.</li>
        <li>The Service is served exclusively over HTTPS.</li>
        <li>Authentication tokens are stored in HTTP-only cookies.</li>
        <li>Access to administrative tools is restricted to authorised KELTA officials.</li>
      </ul>

      <h2>7. Your Rights</h2>
      <p>You may at any time:</p>
      <ul>
        <li>Access and update your profile from your Member Dashboard.</li>
        <li>Request a copy of all data we hold about you.</li>
        <li>Request correction or deletion of your data (subject to legal retention requirements).</li>
        <li>Withdraw your membership.</li>
      </ul>

      <h2>8. Children's Privacy</h2>
      <p>
        The Service is intended for use by adult professionals. We do not knowingly
        collect personal information from anyone under the age of 18.
      </p>

      <h2>9. Cookies</h2>
      <p>
        We use only essential cookies required for authentication and session management.
        We do not use advertising or third-party tracking cookies.
      </p>

      <h2>10. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any updates will be posted
        on this page with a revised "Last updated" date.
      </p>

      <h2>11. Contact</h2>
      <p>
        For privacy-related questions, requests, or grievances, please contact:<br />
        KELTA — Kerala Local Body Technical Assistants Association<br />
        KELTA Office, M.P Building, 12/79 D,<br />
        Vellalassery P.O, N.I.T Via,<br />
        Kozhikode – 673601<br />
        Email: <a href="mailto:keltastate@gmail.com">keltastate@gmail.com</a>
      </p>
    </LegalPage>
  );
}
